import * as api from "../../api";
import {
 ADD_CATEGORY,
 GET_CATEGORY,
 UNPUBLISH_CATEGORY,
 PUBLISH_CATEGORY,
 UPDATE_CATEGORY,
 DELETE_CATEGORY
} from "../../constants/actionTypes";

export const addCategory = (formData) => async (dispatch) => {
    try {
      const response = await api.addCategory(formData);
      dispatch({ type: ADD_CATEGORY, payload: response.data });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };


  export const getCategory = (params) => async (dispatch) => {
    try {
      const { data } = await api.getCategory(params);
      dispatch({ type: GET_CATEGORY, payload: data });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  export const publishCategory = (id) => async (dispatch) => {
    try {
      const { data } = await api.publishCategory(id);
      dispatch({ type: PUBLISH_CATEGORY, payload: data });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
   
  export const unPublishCategory = (id) => async (dispatch) => {
    try {
      const { data } = await api.unPublishCategory(id);
      dispatch({ type: UNPUBLISH_CATEGORY, payload: data });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

   export const updateCategory = (formData) => async (dispatch) => {
    try {
      const response = await api.updateCategory(formData);
      dispatch({ type: UPDATE_CATEGORY, payload: response.data });
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  export const deleteCategory = (id) => async (dispatch) => {
    try {
      const response = await api.deleteCategory(id);
      dispatch({ type: DELETE_CATEGORY, payload: id });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };